import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14.25 3.75H3.75c-.825 0-1.5.675-1.5 1.5v7.5c0 .825.675 1.5 1.5 1.5h10.5c.825 0 1.5-.675 1.5-1.5v-7.5c0-.825-.675-1.5-1.5-1.5zm0 9H3.75v-7.5h10.5v7.5z" fill="#54585D" /></svg>);